export const englishLabels = {
    biosimilarBiologicDrug: "Biosimilar Biologic Drug"
}

export const frenchLabels = {
    biosimilarBiologicDrug: "Médicaments biologiques biosimilaires"
}